import React from 'react';
import './Home.css'
import Product from './Product';
import Product2 from './Product2';


function Home() {
  return (
    <div className='home-body'>
      <div className='img-test'>
        <img className='home-body-img' src='https://m.media-amazon.com/images/I/81xSDWOf8TL._SX3000_.jpg' />
      </div>

      <div className='home-body-1'>
        <Product />
      </div>

      <div style={{ marginTop: "20rem", }}>
        <Product2 />
      </div>

    </div>



  )
}

export default Home